const gr = require("mxgraph-js");

export default class ConfigGraph {
  private _graph: any;

  previewConfig = () => {
    gr.mxGraph.prototype.getAllConnectionConstraints = function(
      terminal: any,
      source: any
      ) {
        if (terminal != null && terminal.shape != null) {
          if (terminal.shape.stencil != null) {
            if (terminal.shape.stencil != null) {
              return terminal.shape.stencil.constraints;
            }
          } else if (terminal.shape.constraints != null) {
            return terminal.shape.constraints;
          }
        }        
        return null;
      };
      
      // Defines the default constraints for all shapes
      const mxPoint = gr.mxPoint;
      
      // Edges have no connection points
      gr.mxPolyline.prototype.constraints = null;
      if (!gr.mxClient.isBrowserSupported()) {
        // Displays an error message if the browser is not supported.
        gr.mxUtils.error("Browser is not supported!", 200, false);
      }
      // Disables the built-in context menu
      const container = document.querySelector("#graphContainer");
      gr.mxEvent.disableContextMenu(container);
      
      // Creates the graph inside the given container
      this._graph = new gr.mxGraph(container);        
      
      this._graph.setConnectable(true);
      this._graph.setPanning(true);
      this._graph.setAllowDanglingEdges(false);
      this._graph.connectionHandler.select = false;
      this._graph.view.setTranslate(80, 80);
      
      this._graph.border = 20;
      this._graph.getView().translate = new mxPoint(this._graph.border/2, this._graph.border/2);
      this._graph.setResizeContainer(true);
      this._graph.graphHandler.setRemoveCellsFromParent(false);  
      
      new gr.mxRubberband(this._graph); 
      this._graph.vertexLabelsMovable = false;
      
      // Specifies the default edge style
      this._graph.getStylesheet().getDefaultEdgeStyle()["edgeStyle"] = "orthogonalEdgeStyle";
      
      // Enables rubberband selection
      new gr.mxRubberband(this._graph);
      
      // Gets the default parent for inserting new cells. This
      // is normally the first child of the root (ie. layer 0).      
      
      this._graph.setEnabled(false)

      return this._graph;
    
  }


}